import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62d00da1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "md-confirm-box"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("信息收集提示");
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "message"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "根据《中华人民共和国电子商务法》及相关法律法规规定，对于申请进入电子商务平台销售商品或者提供服务的电子商务经营者，应当向电子商务平台提交其真实身份信息，进行核验、登记，我们将严格保密、妥善储存您上传的身份证信息，依法采取必要措施（包括不限于：加密、限权等措施）保护您的个人信息安全。")], -1));
const _hoisted_5 = {
  class: "btns"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $options.ifShow,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.ifShow = $event),
    position: "bottom",
    "close-on-click-overlay": false,
    style: {
      "height": "calc(100% - 90px)"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: _normalizeClass(["tit", _ctx.has_message])
    }, [_hoisted_3, _createVNode(_component_van_icon, {
      class: "icon",
      name: "close",
      size: "20",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.btnAction($event, 0), ["stop"]))
    })], 2), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = $event => $options.btnAction($event, 1))
    }, "我已了解并同意收集上述个人信息")])])]),
    _: 1
  }, 8, ["show"])]);
}